module.exports = __webpack_public_path__ + "static/media/IMG_573311.07fd4a5d.jpg";